export const tHead = ['full name', 'position', 'login time', 'exit time', 'total time']
